export default __webpack_public_path__ + "static/alkemi-about2-e6027f8c729cfb9182439956ae26a7f7.jpg";